import { t } from "@/lib/i18n"

import { LandingSection, SectionRule, SectionTitle } from "./section-rule"

const steps = ["seated", "order", "prepare", "pay", "close"]

export function ShiftSection() {
  return (
    <LandingSection>
      <SectionRule>{t("ui.landing.shift.label")}</SectionRule>

      <div className="mt-6 flex flex-col items-start justify-between gap-6 lg:flex-row lg:items-end lg:gap-16">
        <SectionTitle className="max-w-[14em]">{t("ui.landing.shift.title")}</SectionTitle>
        <p className="max-w-xl pb-1 text-sm leading-7 text-muted-foreground lg:text-base">
          {t("ui.landing.shift.description")}
        </p>
      </div>

      {/* No 01/02/03 numbering: the rule already carries the sequence, so the
          numerals would only repeat what the reader can see. */}
      <div className="mt-12 grid gap-8 border-t border-brand sm:grid-cols-2 lg:grid-cols-5">
        {steps.map((step) => (
          <div key={step} className="relative flex flex-col gap-2.5 pt-5">
            <span className="absolute -top-1 left-0 size-2 rounded-full bg-brand" aria-hidden />
            <span className="text-xs font-medium text-muted-foreground">
              {t(`ui.landing.shift.steps.${step}.stage`)}
            </span>
            <h3 className="text-base font-semibold tracking-tight">{t(`ui.landing.shift.steps.${step}.title`)}</h3>
            <p className="text-sm leading-6 text-muted-foreground">
              {t(`ui.landing.shift.steps.${step}.description`)}
            </p>
          </div>
        ))}
      </div>
    </LandingSection>
  )
}
